import {
    useState
} from "react";
import DataGrid, {
    Column,
    Export,
    KeyboardNavigation,
    Paging,
    Pager,
    Popup,
    Selection,
    SearchPanel
} from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import { Typography } from "@mui/material";
import CustomPreparedHeaderCell from "../components/CustomPreparedHeaderCell";
import { logExport, useAuth } from "../hooks/useAuth";
import ExportGrid from '../components/ExportGrid';
import { allowedPageSizes, pageFormats } from "../components/GlobalDataGridConfigurations";
import { FOUOheader } from "../components/FOUO";
import dayjs from 'dayjs';


export default function DataGridSysUsers({ data }) {
    const [selectedRowKey, setSelectedRowKey] = useState(null);
    const [selectedRow, setSelectedRow] = useState(false);
    const { user } = useAuth();


    const dataSource = new CustomStore({
        key: 'id',
        update: () => {/*Do not remove. Required for user to make multiple batch updates*/ },
        load: async () => {
            let checkedData = []
            if (data) {
                var number = 0;
                checkedData = data.map(
                    (
                        {
                            CreationDate,
                            EDIPI,
                            EmailAddress,
                            LastLogon,
                            Status,
                            UserRole,
                            Name
                        }
                    ) => {
                        return {
                            id: number++,
                            UserId: EDIPI,
                            Email: EmailAddress,
                            LastLogin: LastLogon,
                            Status: Status,
                            UserRole: UserRole,
                            Name: Name
                        };
                    }
                );
            }
            return checkedData;
        }
    });

    const onContentReady = async (e) => {
        e.component.getCombinedFilter();
        ;
    }


    const handleFocusedRowChange = (e) => {
        const { data } = e.row;
        setSelectedRowKey(data);
    };

    const handleEnterKeyPress = (e) => {
        const key = e.event?.originalEvent?.key;

        if (key === "Enter") {
            handleRowClick()
        };
    };

    const handleRowClick = () => setSelectedRow(true);



    const handleExport = (e) => {
        logExport(user.email)
        ExportGrid(e, "System_User_Accounts")
    }

    return (<>
        <span
            aria-live="polite"
            aria-relevant="text"
            aria-atomic="true"
        >

            <FOUOheader
                dateString={dayjs.utc().format('MM/DD/YYYY h:mma') + " " + "UTC"}
                heading={"System User Accounts"}
                userEmail={user.email}
            />
            <DataGrid
                columnAutoWidth={true}
                dataSource={dataSource}
                onCellPrepared={CustomPreparedHeaderCell}
                showBorders={true}
                showColumnLines={true}
                showRowLines={true}
                rowAlternationEnabled={true}
                onExporting={e => handleExport(e)}
                onContentReady={(onContentReady)}
                focusedRowEnabled={true}
                onFocusedRowChanged={handleFocusedRowChange}
                onKeyDown={handleEnterKeyPress}
                onRowClick={handleRowClick}
            >
                <Selection mode="single" />
                <Paging defaultPageSize={10} />
                <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                />
                <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                />
                <Column dataField="id" caption="id" visible={false} />
                <Column dataField="UserId" caption="Account ID" />
                <Column dataField="Name" caption="Name" />
                <Column dataField="Email" caption="Email Address" />
                <Column dataField="Status" caption="Status" />
                <Export
                    enabled={true}
                    formats={pageFormats}
                />
            </DataGrid>
        </span>
    </>
    );
}
